module.exports = __webpack_public_path__ + "img/dgm.a2f8317b.png";